import { render, staticRenderFns } from "./Gates.vue?vue&type=template&id=3f3b402f&scoped=true"
import script from "./Gates.vue?vue&type=script&lang=js"
export * from "./Gates.vue?vue&type=script&lang=js"
import style0 from "./Gates.vue?vue&type=style&index=0&id=3f3b402f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b402f",
  null
  
)

export default component.exports